import { Box, styled, Tabs } from '@mui/material';

import { colors } from '../../theme';

export const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 60px 100px;
    background: ${colors.black87};
    
    @media (max-width: 1024px) {
        padding: 40px 60px;
    }
    
    @media (max-width: 768px) {
        padding: 24px 16px;
    }
    
    & .MuiBox-root {
        padding: 0;
    }
`;

export const StyledTabs = styled(Tabs)`
    & .MuiTab-root {
        color: ${colors.white90};
        text-transform: none;
        font: 500 12px/15px 'Inter', sans-serif;
        
        @media (max-width: 768px) {
            font: 500 11px/14px 'Inter', sans-serif;
            min-width: 80px;
            padding: 12px 16px;
        }
    }
    & .MuiTab-root.Mui-selected {
        color: ${colors.lightningYellow};
    }
    & .MuiTabs-indicator {
        height: 1px;
        background-color: ${colors.lightningYellow};
    }
`;
